import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/safe/project',
  owner: '/home',
  authority: 'project',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};